/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["tr[_ngcontent-%COMP%]{line-height:25px;min-height:25px;height:25px}"];
export { styles as styles };
